import { render, staticRenderFns } from "./form-datetime.vue?vue&type=template&id=8c580a8e&scoped=true"
import script from "./form-datetime.ts?vue&type=script&lang=ts&external"
export * from "./form-datetime.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c580a8e",
  null
  
)

export default component.exports